module.exports = "https://cdn.realtymogul.com/static/media/icon_ownit.47125560.svg";